import { SubscriptionRecipientInfo, SubscriptionGeneralUser } from './../../models/SubscriptionBundle';
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { CustomValidators, ConfirmValidParentMatcher, errorMessages } from '../../util/custom-validation';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/services/utilities/language.service';
import { NetworkCoverage } from 'app/models/NetworkCoverage';
import { GeneralUser, ItemConfig } from '@co-assist/library';

const accountTypeMap: Array<any> = [
    { type: 'helped', completeBy: 'helped', title: 'REGISTRATION.STEP.ACCOUNT_CREATION.YOUR_ACCOUNT' },
    { type: 'helper', completeBy: 'helper', title: 'REGISTRATION.STEP.ACCOUNT_CREATION.YOUR_ACCOUNT' },
    { type: 'helped', completeBy: 'helper', title: 'REGISTRATION.STEP.ACCOUNT_CREATION.YOUR_ACCOUNT' },
];
const HELPER = 'helper', HELPED = 'helped';

@Component({
    selector: 'app-account-creation',
    templateUrl: './account-creation.component.html',
    styleUrls: ['./account-creation.component.scss']
})
export class AccountCreationComponent implements OnInit, OnChanges {
    accountType: string;
    allLanguages = [];
    hide: boolean = true;
    matcher = new ConfirmValidParentMatcher(); // errorStateMatcher
    errors: any = errorMessages; // Error List
    profileForm: UntypedFormGroup;
    accountTypeList: Array<any>;
    otherAddress: boolean = false;
    timeZone: string = 'Europe/Paris';
    autoGeneratedPassword: boolean = true;
    @Input() itemConfig: ItemConfig;
    @Input() recipientInformation: SubscriptionRecipientInfo;
    @Input() coverage: NetworkCoverage;
    @Input() helper: SubscriptionGeneralUser;
    @Input() helped: SubscriptionGeneralUser;
    @Output() helperEmitter: EventEmitter<GeneralUser> = new EventEmitter<GeneralUser>();
    @Output() helpedEmitter: EventEmitter<GeneralUser> = new EventEmitter<GeneralUser>();
    @Output() recipientEmitter: EventEmitter<any> = new EventEmitter<any>();
    @Output() currentSection: EventEmitter<{ section, direction }> = new EventEmitter<{ section, direction }>();

    constructor(
        public translate: TranslateService,
        private formBuilder: UntypedFormBuilder,
        private languageService: LanguageService,
        private changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.allLanguages = this.languageService.getLanguageList();
        this.accountTypeList = accountTypeMap;
        this.itemConfig = new ItemConfig(this.itemConfig);
        this.recipientInformation = new SubscriptionRecipientInfo(this.recipientInformation);
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (this.helped && this.helped.firstName && this.helped.firstName !== '') {
            if (this.helper && this.helper.firstName && this.helper.firstName !== '') {
                this.accountType = HELPER;
            } else {
                this.accountType = HELPED;
            }
        }

        this.changeFormGroup();
        this.populateForm();
        this.autoGeneratedPasswordChanged();
        this.changeDetectorRef.markForCheck()
    }

    filtering(accountType: string) {
        this.accountType = accountType;
        if (accountType === HELPED) {
            this.accountTypeList = accountTypeMap.find(item => (item.type === HELPED && item.completeBy === HELPED));
        } else {
            this.accountTypeList = accountTypeMap.filter(item => (item.completeBy === HELPER));
        }
        this.changeFormGroup();
    }
    continue() {
        this.helpedEmitter.emit(this.getHelpedfromFormGroup());
        this.helperEmitter.emit(this.getHelperfromFormGroup());
        this.recipientEmitter.emit(this.recipientInformation);
        this.currentSection.emit({ section: 'account_creation', direction: 'continue' });
    }
    saveRecipientObj(): any {
        if (!this.itemConfig.alreadyOwn) {
            if (this.profileForm.get('addressRadio').value !== 'yes') {
                this.recipientInformation.recipientAddress = this.profileForm.get('recipientAddress').value;
                this.recipientInformation.recipientFirstName = this.profileForm.get('recipientFirstName').value;
                this.recipientInformation.recipientLastName = this.profileForm.get('recipientLastName').value;
            } else {
                this.recipientInformation.recipientAddress = this.profileForm.get('helpedAddress').value;
                this.recipientInformation.recipientFirstName = this.profileForm.get('helpedFirstName').value;
                this.recipientInformation.recipientLastName = this.profileForm.get('helpedLastName').value;
            }
        }
    }

    previous() {
        this.currentSection.emit({ section: 'account_creation', direction: 'back' });
    }

    populateForm(): void {
        if (this.profileForm) {
            if (this.accountType === HELPED) {
                if (this.helped) {
                    this.profileForm.patchValue({
                        helpedCivility: this.helped.civility,
                        helpedFirstName: this.helped.firstName,
                        helpedLastName: this.helped.lastName,
                        helpedEmail: this.helped.email,
                        helpedPhoneNumber: this.helped.phoneNumber,
                        autoGeneratedPassword: this.helped.password == null,
                        passwordGroup: {
                            password: this.helped.password,
                            confirmPassword: this.helped.password
                        },
                        helpedAddress: this.helped.homeAddress || this.coverage.address || null,
                        helpedAddressGps: this.helped.homeAddressGps || this.coverage.gps || null
                    });
                }
            } else {
                if (this.helped) {
                    this.profileForm.patchValue({
                        helpedCivility: this.helped.civility,
                        helpedFirstName: this.helped.firstName,
                        helpedLastName: this.helped.lastName,
                        helpedAddress: this.helped.homeAddress || this.coverage.address || null,
                        helpedAddressGps: this.helped.homeAddressGps || this.coverage.gps || null
                    });
                }
                if (this.helper) {
                    this.profileForm.patchValue({
                        helperCivility: this.helper.civility,
                        helperFirstName: this.helper.firstName,
                        helperLastName: this.helper.lastName,
                        helperEmail: this.helper.email,
                        helperPhoneNumber: this.helper.phoneNumber,
                        autoGeneratedPassword: this.helper.password && this.helper.password == null || false,
                        passwordGroup: {
                            password: this.helper.password,
                            confirmPassword: this.helper.password
                        },
                    });
                }
            }
            if (this.itemConfig && !this.itemConfig.alreadyOwn && this.recipientInformation.recipientAddress) {
                this.profileForm.patchValue({
                    addressRadio: (this.recipientInformation.recipientAddress.length > 0) ? 'yes' : 'no',
                    recipientAddress: this.recipientInformation.recipientAddress,
                    recipientFirstName: this.recipientInformation.recipientFirstName,
                    recipientLastName: this.recipientInformation.recipientLastName
                });
            }
        }
    }

    getHelpedfromFormGroup(): SubscriptionGeneralUser {
        let helped;
        if (this.accountType === HELPED) {
            helped = {
                civility: this.profileForm.get('helpedCivility').value,
                firstName: this.profileForm.get('helpedFirstName').value,
                lastName: this.profileForm.get('helpedLastName').value,
                email: this.profileForm.get('helpedEmail').value,
                autoGeneratedPassword: this.profileForm.get('autoGeneratedPassword').value,
                password: this.profileForm.get('passwordGroup').get('password').value,
                homeAddress: this.profileForm.get('helpedAddress').value,
                homeAddressGps: this.profileForm.get('helpedAddressGps').value,
                phoneNumber: this.profileForm.get('helpedPhoneNumber').value,
                language: this.profileForm.get('helpedLanguage').value,
                timeZone: this.timeZone
            };
        } else {
            helped = {
                civility: this.profileForm.get('helpedCivility').value,
                firstName: this.profileForm.get('helpedFirstName').value,
                lastName: this.profileForm.get('helpedLastName').value,
                homeAddress: this.profileForm.get('helpedAddress').value,
                homeAddressGps: this.profileForm.get('helpedAddressGps').value,
                language: this.profileForm.get('helpedLanguage').value,
                timeZone: this.timeZone
            };
        }
        return new SubscriptionGeneralUser(helped);
    }

    getHelperfromFormGroup(): SubscriptionGeneralUser {
        if (this.accountType !== HELPED) {
            return new SubscriptionGeneralUser({
                civility: this.profileForm.get('helperCivility').value,
                firstName: this.profileForm.get('helperFirstName').value,
                lastName: this.profileForm.get('helperLastName').value,
                email: this.profileForm.get('helperEmail').value,
                autoGeneratedPassword: this.profileForm.get('autoGeneratedPassword').value,
                password: this.profileForm.get('passwordGroup').get('password').value,
                phoneNumber: this.profileForm.get('helperPhoneNumber').value,
                language: this.profileForm.get('helpedLanguage').value,
                timeZone: this.timeZone
            });
        }
    }

    changeFormGroup(): void {
        const commonFields = {
            helpedCivility: [''],
            helpedFirstName: ['', [Validators.required]],
            helpedLastName: ['', [Validators.required]],
            helpedPhoneNumber: ['', [Validators.required]],
            autoGeneratedPassword: [false, []],
            passwordGroup: this.formBuilder.group({
                password: [null, [Validators.required, Validators.minLength(5)]],
                confirmPassword: [null, [Validators.required, Validators.minLength(5)]]
            }, { validators: [CustomValidators.childrenEqual] }),
            helpedAddress: [this.coverage.address, [Validators.required]],
            helpedAddressGps: [this.coverage.gps, [Validators.required]],
            addressRadio: ['', (this.itemConfig && this.itemConfig.alreadyOwn === false) ? [Validators.required] : []],
            recipientAddress: ['', []],
            recipientFirstName: ['', []],
            recipientLastName: ['', []],
            helpedLanguage: [this.languageService.getLanguage(), Validators.required]
        };
        let specificFields = {};
        if (this.accountType === HELPED) {
            specificFields = {
                helpedEmail: ['', [Validators.required, Validators.email]]
            };
        } else if (this.accountType === HELPER) {
            delete commonFields.helpedPhoneNumber;
            specificFields = {
                helperCivility: [''],
                helperFirstName: ['', [Validators.required]],
                helperLastName: ['', [Validators.required]],
                helperEmail: ['', [Validators.required, Validators.email]],
                helperPhoneNumber: ['', [Validators.required]],
            };
        }
        const fields = Object.assign({}, commonFields, specificFields);

        if (!this.profileForm) {
            this.profileForm = this.formBuilder.group(fields);
        } else {
            // add new fields
            Object.keys(fields).forEach(key => {
                if (!Object.keys(this.profileForm.controls).includes(key)) {
                    this.profileForm.addControl(key, new UntypedFormControl(fields[key][0], fields[key][1]));
                }
            });
            // remove unapplicable fields
            Object.keys(this.profileForm.controls).forEach(key => {
                if (!Object.keys(fields).includes(key)) {
                    this.profileForm.removeControl(key);
                }
            });
        }
    }

    updateProfilForm() {
        this.otherAddress = this.profileForm.get('addressRadio').value !== 'yes';
        if (this.otherAddress === true) {
            this.profileForm.get('recipientAddress').setValidators(Validators.required);
            this.profileForm.get('recipientLastName').setValidators(Validators.required);
            this.profileForm.get('recipientFirstName').setValidators(Validators.required);
        } else if (this.otherAddress === false || this.itemConfig.alreadyOwn === true) {
            this.profileForm.get('recipientAddress').clearValidators();
            this.profileForm.get('recipientLastName').clearValidators();
            this.profileForm.get('recipientFirstName').clearValidators();
        }
        this.profileForm.get('recipientAddress').updateValueAndValidity();
        this.profileForm.get('recipientLastName').updateValueAndValidity();
        this.profileForm.get('recipientFirstName').updateValueAndValidity();
    }

    onSubmit() {
        this.profileForm.markAllAsTouched();
        if (this.validateSubmission()) {
            this.saveRecipientObj();
            this.continue();
        }
    }

    autoGeneratedPasswordChanged(internal: boolean = false): void {
        if (this.profileForm) {
            if (this.profileForm.get('autoGeneratedPassword').value) {
                this.profileForm.get(['passwordGroup', 'password']).clearValidators();
                this.profileForm.get(['passwordGroup', 'confirmPassword']).clearValidators();
                this.profileForm.get('passwordGroup').clearValidators();
                this.profileForm.get(['passwordGroup', 'password']).setValue(null);
                this.profileForm.get(['passwordGroup', 'confirmPassword']).setValue(null);

            } else {
                this.profileForm.get(['passwordGroup', 'password']).setValidators([Validators.required, Validators.minLength(5)]);
                this.profileForm.get(['passwordGroup', 'confirmPassword']).setValidators([Validators.required, Validators.minLength(5)]);
                this.profileForm.get('passwordGroup').setValidators(CustomValidators.childrenEqual);
            }
            this.profileForm.get('passwordGroup').updateValueAndValidity();
            this.profileForm.get(['passwordGroup', 'password']).updateValueAndValidity();
            this.profileForm.get(['passwordGroup', 'confirmPassword']).updateValueAndValidity();
            this.validateSubmission();
        }
    }

    getPasswordError(): any {
        if (this.profileForm.get(['passwordGroup', 'password']).errors) {
            if (this.profileForm.get(['passwordGroup', 'password']).errors.hasOwnProperty('minlength')) {
                return this.errors.passwordLength;
            } else {
                return this.errors.passwordRequired;
            }
        }
    }
    getPhoneNumberError(formControlName: string): string {
        if (this.profileForm && this.profileForm.get(formControlName).errors) {
            if (this.profileForm.get(formControlName).errors.hasOwnProperty('required')) {
                return this.errors.phoneNumber;
            } else {
                return this.errors.phoneNumberFormat;
            }
        }
        return '';
    }

    isValid(formControlName: string): boolean {
        if (this.profileForm) {
            if (this.profileForm.get(formControlName).touched) {
                return this.profileForm.get(formControlName).valid;
            }
            return true;
        }
        return true;
    }

    validateSubmission(): boolean {
        return (this.profileForm?.valid);
    }

    placeChanged(place: google.maps.places.PlaceResult, controlName: string) {
        this.profileForm.get(controlName).setValue(place.formatted_address);
    }
}
